import type { JSX, ReactNode } from 'react';
import type { Palette } from '../_theme/palette.js';
import { CloseIcon } from './Icons.js';
import { IconButton } from './IconButton.js';

interface GradientHeaderProps {
  palette: Palette;
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  onClose: () => void;
  useGradient?: boolean;
}

export function GradientHeader({
  palette,
  title,
  subtitle,
  icon,
  onClose,
  useGradient = true,
}: GradientHeaderProps): JSX.Element {
  const background = useGradient
    ? `linear-gradient(135deg, ${palette.primary}, ${palette.primaryDeep})`
    : palette.primary;

  return (
    <div
      style={{
        background,
        color: palette.onPrimary,
        padding: '16px 20px',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
      }}
    >
      {icon && (
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 40,
            height: 40,
            borderRadius: 10,
            background: 'rgba(255,255,255,0.18)',
          }}
        >
          {icon}
        </span>
      )}
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 16, fontWeight: 600, lineHeight: 1.2 }}>{title}</div>
        {subtitle && <div style={{ fontSize: 12, opacity: 0.82, marginTop: 2 }}>{subtitle}</div>}
      </div>
      <IconButton onClick={onClose} ariaLabel="Close" color={palette.onPrimary}>
        <CloseIcon />
      </IconButton>
    </div>
  );
}
